// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__rq5cA","signatureButtonsRight":"ModalSign_signatureButtonsRight__3wRne"};